import { CSSObject } from '@emotion/react'
import { fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'
import { sharedColors, sharedStyles } from '../../sharedStyles'

const header: CSSObject = {
  ...sharedStyles.headerLayout,
  backgroundColor: 'white',
  borderRadius: '3px 3px 0 0',
  padding: '12px 15px 11px 10px',
  width: '375px',
}

const avatarUsername: CSSObject = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
}

const avatar: CSSObject = {
  marginInlineEnd: 12,
}

const collabAccountName: CSSObject = {
  display: 'inline',
}

const collabSpan: CSSObject = {
  color: 'black',
  fontWeight: fontWeights.normal,
}

const collabAccountWrapper = (hasAccount: string): CSSObject => ({
  paddingBlockEnd: '20px',
  fontWeight: fontWeights.bolder,
  color: `${hasAccount}` ? `${sharedColors.darkGreyText}` : colors.n8.base,
  inlineSize: '285px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  paddingLeft: '10px',
  height: '34px',
  fontSize: fontSizes.medium,
})

const emptyCollabStyles = {
  color: colors.orange.base,
  display: 'inline',
  fontSize: fontSizes.small,
  fontWeight: fontWeights.bolder,
}

const account = (
  shouldShiftUp: boolean,
  display: string,
  instagramCollab?: boolean
): CSSObject => ({
  ...sharedStyles.accountPosition(shouldShiftUp, display),
  paddingLeft: instagramCollab ? '10px' : '0',
  boxSizing: instagramCollab ? 'initial' : 'border-box',
})

const location: CSSObject = {
  ...sharedStyles.locationPosition,
  fontSize: fontSizes.xSmall,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxInlineSize: '250px',
}

const input: CSSObject = {
  marginBlockStart: 0,
  marginInlineEnd: 10,
  marginBlockEnd: 5,
  marginInlineStart: 10,
}

const musicContainer: CSSObject = {
  ...location,
  borderRadius: '4px',
  inlineSize: '285px',
  insetBlockStart: '16px',
  insetInlineStart: '42px',
  paddingBottom: '4px',
}

const music = (isHovered: boolean, readOnly: boolean): CSSObject => ({
  backgroundColor: isHovered && !readOnly ? colors.n10.base : 'inherit',
  border: 'none',
  fontSize: `${fontSizes.xSmall}`,
  inlineSize: '285px',
  padding: '0 2px',
  '&::placeholder': {
    color: colors.n6.base,
  },
  '&:active, &:focus': {
    border: 'none',
    outline: 'none',
  },
})

const styles = {
  account,
  avatar,
  avatarUsername,
  collabAccountName,
  collabAccountWrapper,
  collabSpan,
  emptyCollabStyles,
  header,
  input,
  location,
  music,
  musicContainer,
}

export { styles }
